import { AxiosResponse } from 'axios';
import { Diskusi } from '../../entities/Diskusi';
import { DiskusiResponse } from '../contracts/Diskusi';

export class DiskusiDataMapper {
  public convertListDiskusiDataFromApi(result: AxiosResponse<any>): DiskusiResponse {
    if (!result || !result.data || !result.data.data) {
      return {
        data: [],
        totalPage: 0,
        totalRow: 0,
      };
    }

    const { data, pagination } = result.data;
    const diskusiArray = Array.isArray(data) ? data : [];

    const diskusiList: Diskusi[] = diskusiArray.map((item: any) => ({
      id: item.id || 0,
      username: item.username || '',
      user_id: item.user_id || 0,
      message: item.message || '',
      created_at: item.created_at || '',
      diskusi_pengetahuan_id: item.diskusi_pengetahuan_id || 0,
    }));

    const totalRows = pagination?.total_rows || diskusiList.length;
    const perPage = 10;
    const totalPage = Math.ceil(totalRows / perPage);

    return {
      data: diskusiList,
      totalPage: totalPage,
      totalRow: totalRows,
    };
  }
}
